<template>
    <div>
        <app-header v-if="$route.name !== 'login'"></app-header>
        <div style="min-height: 100vh">
           <slot/>
        </div>
       
        <app-footer v-if="$route.name !== 'login'"></app-footer>
    </div>
</template>

<script>
  import AppHeader from '../components/client/AppHeader.vue'
  import AppFooter from '../components/client/AppFooter.vue'

  export default {
    components: {
      AppHeader,
      AppFooter
    }
  }
</script>